import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as DeleteFilled } from 'assert/images/Profile/delete.svg';
import { ReactComponent as EditFilled } from 'assert/images/Profile/edit.svg';
import { SkillContainer } from 'pages/addprofile/Profile.style';
import {
  Input,
  Select,
  BasicIconButton,
  Button,
  BrandIconSpinner,
} from 'components';
import {
  InsertSkills,
  updateSkillsList,
  deleteSkills,
  getSkillsByuserId,
  DragAndDropSkills,
} from 'redux/features/SkillSlice';
import { ReactSortable } from 'react-sortablejs';
import { ReactComponent as Drag } from 'assert/images/Jobs/drag.svg';
import { Notification } from 'components/CustomNotification';
import { t } from 'i18next';
import useWindowDimensions from 'components/Dimention';
import { swipeModalWidth } from 'utils/helper';

const SkillForms = ({ list }) => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;
  const { getSkills } = useSelector((state) => state?.SkillsSlice);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [dragitems, setDragitems] = useState();
  const [loading, setloading] = useState(false);
  const [updateBtn, setUpdateBtn] = useState(false);
  const [skillList, setSkillList] = useState([]);
  const [skillDetails, setSkillDetails] = useState({
    skill: '',
    experience: '',
    id: '',
  });
  const [errMsg, setErrmsg] = useState({
    skill: '',
  });

  useEffect(() => {
    if (getProfile?.userId) {
      dispatch(getSkillsByuserId());
    }
  }, [getProfile]);

  useEffect(() => {
    // if (getSkills && getSkills[0].data?.length > 0) {
    const data = getSkills?.[0]?.data
      ? JSON.stringify(getSkills?.[0]?.data)
      : '[]';
    setSkillList(JSON.parse(data));
    // }
  }, [getSkills]);

  const handleChange = useCallback((data, name) => {
    setSkillDetails((prevState) => ({
      ...prevState,
      [name]: data,
    }));
  }, []);

  const resetValue = () => {
    setSkillDetails({
      id: '',
      skill: '',
      experience: '',
    });
    setErrmsg({
      skill: '',
    });
    setUpdateBtn(false);
    dispatch(getSkillsByuserId());
  };

  const handleSubmit = () => {
    if (skillDetails.skill?.trim()) {
      const skillExists = skillList.some(
        (item) =>
          item.skill.toLowerCase() === skillDetails.skill.toLowerCase() &&
          item.id !== skillDetails.id
      );

      if (skillExists) {
        Notification('error', 'This skill already exists.');
        return;
      }
      setloading(true);
      if (updateBtn) {
        dispatch(updateSkillsList(skillDetails))
          .then(() => {
            resetValue();
            setloading(false);
          })
          .catch((err) => {
            Notification('warning', err.response?.data?.message);
            setloading(false);
          });
      } else {
        dispatch(InsertSkills(skillDetails, getProfile?.userId))
          .then(() => {
            resetValue();
            setloading(false);
          })
          .catch((err) => {
            Notification('warning', err.response?.data?.message);
            setloading(false);
          });
      }
    } else {
      setErrmsg({
        skill: 'Skill is required',
      });
    }
  };

  const onEditSkills = useCallback(
    (data) => {
      setUpdateBtn(true);
      setSkillDetails((prevState) => ({
        ...prevState,
        skill: data.skill,
        experience: data.experience,
        id: data.id,
      }));
    },
    [skillDetails]
  );

  const onDeleteSkills = useCallback(
    (deleteId) => {
      setloading(true);
      dispatch(deleteSkills(deleteId))
        .then(() => {
          setloading(false);
          dispatch(getSkillsByuserId());
        })
        .catch((err) => {
          setloading(false);
          Notification('warning', err?.response?.data?.message);
        });
    },
    [skillList]
  );

  const OrderChangeApi = () => {
    setDragitems(true);
  };

  useEffect(() => {
    if (dragitems) {
      const Ids = skillList?.map((item) => item.id);
      dispatch(DragAndDropSkills(Ids))
        .then((res) => {
          if (res?.data?.success) {
            Notification('success', res?.data?.message);
            dispatch(getSkillsByuserId());
            setDragitems(false);
          }
        })
        .catch((value) => {
          setDragitems(false);
          Notification('error', value?.data?.message);
        });
    }
  }, [dragitems, skillList]);

  return (
    <SkillContainer>
      <BrandIconSpinner loading={loading} />
      <div className="skill-inputs">
        <Input
          label={t('profile.Skills')}
          value={skillDetails.skill}
          required
          onChange={(data) => handleChange(data, 'skill')}
          errMsg={errMsg.skill}
        />
        <Select
          Options={list}
          label={t('profile.Experience')}
          value={skillDetails.experience}
          onChange={(data) => handleChange(data.target.value, 'experience')}
          errMsg={errMsg.experience}
        />
        <div className="add-icon">
          <Button
            onClick={handleSubmit}
            label={updateBtn ? t('profile.Update') : t('profile.ProfileAdd')}
            type="text"
          />
          {updateBtn && (
            <Button
              onClick={resetValue}
              label={'Cancel'}
              type="text"
              color="error"
            />
          )}
        </div>
      </div>
      <div className={'skill-content'}>
        {skillList?.length > 0 && (
          <ReactSortable
            dragClass="sortableDrag"
            animation="200"
            easing="ease-out"
            handle=".handle"
            list={skillList}
            setList={setSkillList}
            onEnd={OrderChangeApi}
          >
            {skillList.map((data, index) => {
              return (
                <div className="show-skills" key={index}>
                  {data?.experience
                    ? data?.skill + ' - ' + data.experience
                    : data?.skill}
                  <div className="icon-action">
                    <div className="edit-icon">
                      <BasicIconButton
                        size="small"
                        icon={<EditFilled />}
                        onClick={() => onEditSkills(data)}
                        ariaLabel={'edit-icon'}
                      />
                    </div>
                    <div className="remove-icon">
                      <BasicIconButton
                        size="small"
                        icon={<DeleteFilled />}
                        onClick={() => onDeleteSkills(data.id)}
                        ariaLabel={'remove-icon'}
                      />
                    </div>
                    {!isSmallScreen ? (
                      <BasicIconButton
                        size="small"
                        className={'handle form-drag-icon'}
                        icon={<Drag />}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              );
            })}
          </ReactSortable>
        )}
      </div>
    </SkillContainer>
  );
};

export default SkillForms;
